module.exports = __webpack_public_path__ + "static/media/search-reg-btn.7ffc8a3c.svg";